import fields from '@/sui/data/sheets/edit/fields'
import bounds from '@/sui/data/sheets/edit/bounds'
import patient from '@/sui/data/sheets/edit/patient'
import catheter from '@/sui/data/sheets/edit/catheter'
import bact from '@/sui/data/sheets/edit/bact'
import notes from '@/sui/data/sheets/edit/notes'

import common from '@/sui/data/sheets/edit/notes/common'

import assert from '@/sui/tools/assert'

function checkKts (result, sheet) {
  const type = sheet[fields.unitType]
  if (type == null) {
    return
  }

  const mix = type.match(/^MIX/) != null &&
        sheet[fields.mixManagment] === 2
  const neo = mix || type.match(/^NEO/) != null
  if (!neo) {
    return
  }
  const kts = sheet[fields.catheterArray]
  const ktsNotes = result[fields.catheterArray]
  assert.equals(kts.length, ktsNotes.length)

  for (let i in kts) {
    const kt = kts[i]
    const ktType = kt[fields.catheterType]
    if (ktType === 3 || ktType === 1 || ktType === 4) {
      return
    }
  }

  const note = result[fields.unitType]
  note.type = 'error'
  note.tooltip = `Une fiche nouveau-né doit inclure au moins un cathéter
central ou un cathéter ombilical`
}

function checkBacteremias (result, sheet) {
  const type = sheet[fields.unitType]
  const neoPedMix = type != null && type.match(/^(NEO|MIX|PED)/) != null

  const bacts = sheet[fields.bactArray]
  const bactsNotes = result[fields.bactArray]
  assert.equals(bacts.length, bactsNotes.length)

  for (let i in bacts) {
    const bact = bacts[i]
    const notes = bactsNotes[i]
    common.checkBactOrigin(result, sheet, neoPedMix)

    const entrance = bact[fields.entrance]
    if (!neoPedMix && entrance === 3) {
      const note = notes[fields.entrance]
      note.type = 'error'
      note.tooltip = `Porte d'entrée impossible pour un adulte`
    }

    common.checkBactMicroOrg(notes, bact, fields.bacteremia)
  }
}

function checkDates (result, sheet) {
  const birthdate = notes.dateField(result, sheet, patient.birthdate)
  const entrydate = notes.dateField(result, sheet, patient.entrydate)
  const deathdate = notes.dateField(result, sheet, patient.deathDate)
  const exitdate = notes.dateField(result, sheet, patient.exitDate)
  const oldest = notes.oldest['2019']
  const newest = notes.newest['2019']

  const comparisons = [
    { f: oldest, s: birthdate },
    { f: oldest, s: entrydate },
    { f: oldest, s: exitdate },
    { f: oldest, s: deathdate },

    { f: birthdate, s: newest },
    { f: entrydate, s: newest },
    { f: exitdate, s: newest },
    { f: deathdate, s: newest },

    { f: birthdate, s: entrydate },
    { f: birthdate, s: exitdate },
    { f: birthdate, s: deathdate },

    { f: entrydate, s: deathdate },
    { f: entrydate, s: exitdate }
  ]

  const kts = sheet[fields.catheterArray]
  const ktsNotes = result[fields.catheterArray]
  assert.equals(kts.length, ktsNotes.length)

  for (let i in kts) {
    const kt = kts[i]
    const note = ktsNotes[i]
    const insertiondate = notes.dateField(note, kt, catheter.insertionDate)
    const removaldate = notes.dateField(note, kt, catheter.removalDate)
    comparisons.push(
      { f: oldest, s: insertiondate },
      { f: oldest, s: removaldate },
      { s: newest, f: insertiondate },
      { s: newest, f: removaldate },

      { f: birthdate, s: insertiondate },
      { f: birthdate, s: removaldate },

      { f: insertiondate, s: removaldate },
      { f: insertiondate, s: deathdate },
      { f: insertiondate, s: exitdate },

      { f: entrydate, s: removaldate },
      { f: removaldate, s: deathdate },
      { f: removaldate, s: exitdate }
    )
  }

  const bacts = sheet[fields.bactArray]
  const bactsNotes = result[fields.bactArray]
  assert.equals(bacts.length, bactsNotes.length)

  for (let i in bacts) {
    const bactf = bacts[i]
    const note = bactsNotes[i]

    const episoddate = notes.dateField(note, bactf, bact.episod)
    const insertiondate = notes.dateField(note, bactf, bact.insertionDate.v1)
    const insertiondate2 = notes.dateField(
      note, bactf, bact.enfInsertionDate.v2
    )
    const removaldate = notes.dateField(note, bactf, bact.removalDate.v2)

    comparisons.push(
      { f: oldest, s: episoddate },
      { f: oldest, s: insertiondate },
      { f: oldest, s: insertiondate2 },
      { f: oldest, s: removaldate },

      { s: newest, f: episoddate },
      { s: newest, f: insertiondate },
      { s: newest, f: insertiondate2 },
      { s: newest, f: removaldate },

      { f: birthdate, s: episoddate },
      { f: episoddate, s: deathdate },
      { f: episoddate, s: exitdate },

      { f: birthdate, s: insertiondate },
      { f: birthdate, s: insertiondate2 },
      { f: insertiondate, s: removaldate },
      { f: insertiondate, s: deathdate },
      { f: insertiondate, s: exitdate },
      { f: insertiondate2, s: removaldate },
      { f: insertiondate2, s: deathdate },
      { f: insertiondate2, s: exitdate },

      { f: birthdate, s: removaldate },
      { f: entrydate, s: removaldate },
      { f: removaldate, s: deathdate },
      { f: removaldate, s: exitdate }
    )
  }

  notes.compareDates(comparisons)
}

function checkNumericValues (result, sheet) {
  const numericChecks = [
    bounds.gestationalAge,
    bounds.birthWeight,
    bounds.igsII,
    bounds.pimII,
    bounds.cribII
  ]
  notes.checkNumerics(result, sheet, numericChecks)
}

export default {
  build2019: function (result, sheet) {
    checkDates(result, sheet)
    checkNumericValues(result, sheet)
    common.checkPatientOrigin(result, sheet, 2019)
    checkKts(result, sheet)
    checkBacteremias(result, sheet)
    return result
  }
}
